/* eslint-disable jsx-a11y/anchor-is-valid */
import { useNavigate, useSearchParams } from 'react-router-dom'

import { EnumDispatcherRoutes } from '@/app/router/routerConstants'
import DotsSvg from '@/assets/img/dots.svg'
import ProfileIcon from '@/assets/img/ico-view-profile.svg?react'
import Button from '@/compoments/common/Button'
import Dropdown from '@/compoments/common/Dropdown'
import Pagination from '@/compoments/common/Pagination'
import RatingWidthIcon from '@/compoments/common/RatingWidthIcon'
import SearchForm from '@/compoments/common/SearchForm'
import SelectBox from '@/compoments/common/SelectBox'
import UserPart from '@/compoments/common/UserPart'
import DropdownList from '@/compoments/DropdownList'
import AddCustomerModal from '@/compoments/modals/AddCustomerModal'
import PageLoader from '@/compoments/PageLoader'
import { useGetDispatcherAllCustomersQuery } from '@/services/dispatcher/dispather'
import { optionsOnlineStatus } from '@/utils/selectsOptionsConst'
import { useState } from 'react'

export const CustomerManagementPage = () => {
    const [addCustomerModalOpen, setAddCustomerModalOpen] = useState(false)
    const [searchParams, setSearchParams] = useSearchParams()
    const navigate = useNavigate()
    const queryString = searchParams.toString()

    const { data, isLoading } = useGetDispatcherAllCustomersQuery(queryString)

    const pageData = data?.data

    const editHandler = (id: number) => {
        navigate(
            `${EnumDispatcherRoutes.DISPATCHER_CUSTOMERS_MANAGEMENT}/${id}`,
        )
    }

    const filterHandler = (
        name: string,
        value: string | number | undefined,
    ) => {
        setSearchParams((prev: URLSearchParams) => {
            prev.set('page', '1')
            if (value) {
                prev.set(name, String(value))
            } else {
                prev.delete(name)
            }
            return prev
        })
    }
    if (isLoading) {
        return <PageLoader />
    }
    return (
        <main className="content">
            <div className="px-container">
                <div className="table-group">
                    <div className="table-header flex items-center justify-between">
                        <div className="table-tools">
                            <SelectBox
                                options={optionsOnlineStatus}
                                placeholder={'Status'}
                                onChange={option =>
                                    filterHandler('status', option?.value)
                                }
                                isClearable={true}
                            />
                        </div>
                        <div className="table-tools">
                            <Button
                                onClick={() => setAddCustomerModalOpen(true)}
                                size="sm"
                                variant="primary-gradient"
                            >
                                <svg
                                    width="20"
                                    height="20"
                                    viewBox="0 0 20 20"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.8327 9.16675H10.8327V4.16675H9.16602V9.16675H4.16602V10.8334H9.16602V15.8334H10.8327V10.8334H15.8327V9.16675Z"
                                        fill="white"
                                    ></path>
                                </svg>
                                <span className="text--xs">Add Customer</span>
                            </Button>
                            <SearchForm />
                        </div>
                    </div>

                    <div className="table-body table-responsive p-0">
                        <table className="table">
                            <thead>
                                <tr>
                                    <th>Full Name</th>
                                    <th>Phone</th>
                                    <th>Address</th>
                                    <th style={{ width: '80px' }}>
                                        Last Engagement Data
                                    </th>
                                    <th style={{ width: '80px' }}>
                                        Customer Rating
                                    </th>
                                    <th
                                        style={{ width: '10px' }}
                                        className="text-right"
                                    >
                                        Actions
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {pageData && pageData.length > 0 ? (
                                    pageData.map((customer, index) => (
                                        <tr key={index}>
                                            <td>
                                                <UserPart
                                                    src={customer.photo}
                                                    name={customer.fullName}
                                                    email={customer.email}
                                                />
                                            </td>
                                            <td>
                                                <span className="text--xs">
                                                    {customer.phone}
                                                </span>
                                            </td>
                                            <td>
                                                <span className="text--12 text-color-1 text-wrap">
                                                    {[
                                                        customer?.address
                                                            ?.street,
                                                        customer?.address?.city,
                                                        customer?.address
                                                            ?.state,
                                                        customer?.address
                                                            ?.postalCode,
                                                        customer?.address
                                                            ?.country,
                                                    ]
                                                        .filter(Boolean)
                                                        .join(', ')}
                                                </span>
                                            </td>
                                            <td className="text-center">
                                                {customer.engagement}%
                                            </td>
                                            <td>
                                                <RatingWidthIcon
                                                    rating={customer.rating}
                                                />
                                            </td>
                                            <td className="text-right sticky-end">
                                                <Dropdown
                                                    closeSelf={true}
                                                    dropdownClasses="flex flex-col"
                                                    button={
                                                        <span className="ico">
                                                            <img
                                                                src={DotsSvg}
                                                                alt=""
                                                            />
                                                        </span>
                                                    }
                                                    menuClassName="dropdown-md"
                                                    menu={
                                                        <DropdownList
                                                            list={[
                                                                {
                                                                    title: 'View',
                                                                    icon: (
                                                                        <ProfileIcon />
                                                                    ),
                                                                    action: () =>
                                                                        editHandler(
                                                                            customer.id,
                                                                        ),
                                                                },
                                                            ]}
                                                        />
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5}>
                                            <h4 className="text-center">
                                                Customers not found
                                            </h4>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
                <Pagination
                    pagination={data?.pagination}
                    onPageChange={() => {}}
                />
            </div>
            {addCustomerModalOpen && (
                <AddCustomerModal
                    isOpen={addCustomerModalOpen}
                    onClose={() => setAddCustomerModalOpen(false)}
                />
            )}
        </main>
    )
}
